import { render, staticRenderFns } from "./BlockInterpreterModal.vue?vue&type=template&id=654d3418&scoped=true&"
import script from "./BlockInterpreterModal.vue?vue&type=script&lang=js&"
export * from "./BlockInterpreterModal.vue?vue&type=script&lang=js&"
import style0 from "./BlockInterpreterModal.vue?vue&type=style&index=0&id=654d3418&prod&lang=css&"
import style1 from "./BlockInterpreterModal.vue?vue&type=style&index=1&id=654d3418&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654d3418",
  null
  
)

export default component.exports